module.exports = "img/photo31.8091f5.jpg";